import { setupFooterTabs } from 'client/javascript/on_load_functions_for_main';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { trackInteraction } from './analytics';

export function listenForFooterInteractionEvents(_document) {
  Array.from(_document.querySelectorAll('.page-footer a')).forEach(link => {
    link.addEventListener('click', () => {
      trackInteraction({
        label: 'Footer - click link',
        toPath: link.getAttribute('href')
      });
    });
  });

  const locationsDropdown = document.querySelector('.footer-locations-cta');
  const locationsContainer = document.getElementById('footer-locations-container');
  const locationsDropdownArrow = document.getElementById('footer-locations-arrow');
  if (locationsDropdown) {
    locationsDropdown.addEventListener('click', () => {
      locationsContainer.classList.toggle('footer-locations-active');
      locationsDropdownArrow.classList.toggle('triangle-icon--up');
    });
  }

  onContentLoaded(setupFooterTabs);
}
